import React, { Component } from "react"
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs'
import { IntlProvider, addLocaleData, FormattedMessage } from "react-intl"
import en from "react-intl/locale-data/en"
import enMessages from "../../locales/en.js"
import Img from 'gatsby-image'
import it from "react-intl/locale-data/it"
import itMessages from "../../locales/it.js"

import Nav from '../Nav'

addLocaleData([...it, ...en])

const messages = {
  it: itMessages,
  en: enMessages
}

const locales = ["en", "it"]

import 'react-tabs/style/react-tabs.scss'

class HouseTabs extends Component {
  render() {

    let rooms = this.props.house
    let locale = this.props.locale
    let prefix = locale === "en" ? "en" : locale;

    return(
      <div className="house-tabs">
        <div className="wrap--mini">
          <div className="house-tabs__title">
            <IntlProvider
              locale={ prefix }
              messages={ messages[prefix] }
            >
              <FormattedMessage id={"rooms"} />
            </IntlProvider>
          </div>
        </div>
        <div className="house-tabs__body">
          <Tabs>
            <div className="wrap">
              <TabList>
                { rooms.map(room => {

                  let label = room.kind.name.replace(/[^a-zA-Z0-9]/g,'')

                  return(
                    <Tab
                      key={ room.id }
                      className={`house-tabs__tab ${label}`}
                    >
                      <div className="house-tabs__name">
                        <h4>
                          { room.kind.name }
                        </h4>
                        <p className="house-tabs__active" />
                      </div>
                    </Tab>
                  )
                })}
              </TabList>
            </div>
            { rooms.map(room => {

              let image = room.gallery[0]

              return(
                <TabPanel key={ room.id }>
                  <div className="wrap">
                    <div className="house-tabs__panel">
                      <div className="house-tabs__description">
                        <div className="house-tabs__description__title">
                          { room.kind.name }
                        </div>
                        <div className="formatted-content">
                          <div
                            dangerouslySetInnerHTML={{
                              __html: room.description
                            }}
                          />
                        </div>
                      </div>
                      <div className="house-tabs__image">
                        <Img
                          style={{
                            position: "absolute",
                            left: 0,
                            top: 0,
                            width: "100%",
                            height: "100%",
                            zIndex: 1
                          }}
                          sizes={ image.sizes }
                        />
                      </div>
                    </div>
                  </div>
                </TabPanel>
              )
            })}
          </Tabs>
        </div>
      </div>
    )
  }
}

export default HouseTabs



// WEBPACK FOOTER //
// ./src/components/HouseTabs/index.js